import { HkidGenerator } from '../generators/HkidGenerator.js';
import { TwidGenerator } from '../generators/TwidGenerator.js';
import { AadhaarGenerator } from '../generators/AadhaarGenerator.js';
import { NricGenerator } from '../generators/NricGenerator.js';
import { FinGenerator } from '../generators/FinGenerator.js';
import { PanGenerator } from '../generators/PanGenerator.js';
import { SsnGenerator } from '../generators/SsnGenerator.js';
import { SinGenerator } from '../generators/SinGenerator.js';
import { NinoGenerator } from '../generators/NinoGenerator.js';
import { BsnGenerator } from '../generators/BsnGenerator.js';
import { CpfGenerator } from '../generators/CpfGenerator.js';
import { RutGenerator } from '../generators/RutGenerator.js';
import { CuilGenerator } from '../generators/CuilGenerator.js';
import { RfcGenerator } from '../generators/RfcGenerator.js';
import { PersonalnummerGenerator } from '../generators/PersonalnummerGenerator.js';
import { PersonnummerGenerator } from '../generators/PersonnummerGenerator.js';
import { CprGenerator } from '../generators/CprGenerator.js';
import { PeselGenerator } from '../generators/PeselGenerator.js';
import { CnpGenerator } from '../generators/CnpGenerator.js';

// New generators
import { AusGenerator } from '../generators/AusGenerator.js';
import { NzGenerator } from '../generators/NzGenerator.js';
import { JpGenerator } from '../generators/JpGenerator.js';
import { KrGenerator } from '../generators/KrGenerator.js';
import { CnGenerator } from '../generators/CnGenerator.js';
import { ThGenerator } from '../generators/ThGenerator.js';
import { MyGenerator } from '../generators/MyGenerator.js';
import { PhGenerator } from '../generators/PhGenerator.js';
import { VnGenerator } from '../generators/VnGenerator.js';
import { IdGenerator } from '../generators/IdGenerator.js';
import { ZaGenerator } from '../generators/ZaGenerator.js';
import { EgGenerator } from '../generators/EgGenerator.js';
import { NgGenerator } from '../generators/NgGenerator.js';
import { KeGenerator } from '../generators/KeGenerator.js';
import { GhGenerator } from '../generators/GhGenerator.js';
import { FrGenerator } from '../generators/FrGenerator.js';
import { DeGenerator } from '../generators/DeGenerator.js';
import { ItGenerator } from '../generators/ItGenerator.js';
import { EsGenerator } from '../generators/EsGenerator.js';
import { PtGenerator } from '../generators/PtGenerator.js';
import { RuGenerator } from '../generators/RuGenerator.js';
import { UaGenerator } from '../generators/UaGenerator.js';
import { TrGenerator } from '../generators/TrGenerator.js';
import { IlGenerator } from '../generators/IlGenerator.js';
import { ArGenerator } from '../generators/ArGenerator.js';
import { SaGenerator } from '../generators/SaGenerator.js';
import { PkGenerator } from '../generators/PkGenerator.js';
import { BdGenerator } from '../generators/BdGenerator.js';
import { LkGenerator } from '../generators/LkGenerator.js';
import { MmGenerator } from '../generators/MmGenerator.js';

/**
 * Factory pattern for creating generators (Open/Closed Principle)
 */
export class GeneratorFactory {
  constructor() {
    this.generators = new Map([
      // Existing generators
      ['HKID', HkidGenerator],
      ['TWID', TwidGenerator],
      ['AADHAAR', AadhaarGenerator],
      ['NRIC', NricGenerator],
      ['FIN', FinGenerator],
      ['PAN', PanGenerator],
      ['SSN', SsnGenerator],
      ['SIN', SinGenerator],
      ['NINO', NinoGenerator],
      ['BSN', BsnGenerator],
      ['CPF', CpfGenerator],
      ['RUT', RutGenerator],
      ['CUIL', CuilGenerator],
      ['RFC', RfcGenerator],
      ['PERSONNUMMER', PersonnummerGenerator],
      ['PERSONALNUMMER', PersonalnummerGenerator],
      ['CPR', CprGenerator],
      ['PESEL', PeselGenerator],
      ['CNP', CnpGenerator],
      
      // New comprehensive generators
      ['AUS', AusGenerator],           // Australia - Tax File Number
      ['NZ', NzGenerator],             // New Zealand - IRD Number
      ['JP', JpGenerator],             // Japan - My Number
      ['KR', KrGenerator],             // South Korea - RRN
      ['CN', CnGenerator],             // China - Resident Identity Card
      ['TH', ThGenerator],             // Thailand - National ID
      ['MY', MyGenerator],             // Malaysia - NRIC
      ['PH', PhGenerator],             // Philippines - UMID
      ['VN', VnGenerator],             // Vietnam - Citizen Identity Card
      ['ID', IdGenerator],             // Indonesia - NIK
      ['ZA', ZaGenerator],             // South Africa - ID Number
      ['EG', EgGenerator],             // Egypt - National ID
      ['NG', NgGenerator],             // Nigeria - NIN
      ['KE', KeGenerator],             // Kenya - National ID
      ['GH', GhGenerator],             // Ghana - Ghana Card
      ['FR', FrGenerator],             // France - INSEE Number
      ['DE', DeGenerator],             // Germany - Tax ID
      ['IT', ItGenerator],             // Italy - Fiscal Code
      ['ES', EsGenerator],             // Spain - DNI
      ['PT', PtGenerator],             // Portugal - Citizen Card
      ['RU', RuGenerator],             // Russia - Passport Number
      ['UA', UaGenerator],             // Ukraine - Tax Number
      ['TR', TrGenerator],             // Turkey - TC Kimlik No
      ['IL', IlGenerator],             // Israel - ID Number
      ['AR', ArGenerator],             // UAE - Emirates ID
      ['SA', SaGenerator],             // Saudi Arabia - National ID
      ['PK', PkGenerator],             // Pakistan - CNIC
      ['BD', BdGenerator],             // Bangladesh - National ID
      ['LK', LkGenerator],             // Sri Lanka - National ID
      ['MM', MmGenerator]              // Myanmar - NRC
    ]);
  }

  create(type) {
    const GeneratorClass = this.generators.get(type?.toUpperCase());
    if (!GeneratorClass) {
      throw new Error(`Unsupported ID type: ${type}`);
    }
    return new GeneratorClass();
  }

  register(type, GeneratorClass) {
    this.generators.set(type.toUpperCase(), GeneratorClass);
  }

  getSupportedTypes() {
    return Array.from(this.generators.keys());
  }
}